import React from "react";
import styled from "styled-components";
import colors from "../config/colors";

import Headline from "../components/Headline";
import Strong from "../components/Strong";
import ContentSection from "../components/ContentSection";
import DoItems from "../components/DoItems";
import Row from "../components/Row";
import Col from "../components/Col";

import frontendSvg from "../images/do/frontend.svg";
import consultingSvg from "../images/do/consulting.svg";
import mobileSvg from "../images/do/mobile.svg";
import qualitySvg from "../images/do/quality.svg";

// TODO use fragments instead of spans in headlines when gatsby has react 16
export default () => (
  <ContentSection color={colors.gray}>
    <Headline color="white">
      Meine <Strong>Kompetenzen</Strong>
    </Headline>
    <Row>
      <Col>
        <DoItems.DoItem
          headline={
            <span>
              Frontend <Strong>Development</Strong>
            </span>
          }
          icon={frontendSvg}
        >
          <DoItems.Row>Entwicklung von Single-Page-Applikationen</DoItems.Row>
          <DoItems.Row>Progressive Enhancement</DoItems.Row>
          <DoItems.Row>API-Design (REST + GraphQL)</DoItems.Row>
          <DoItems.Row>Softwarearchitektur</DoItems.Row>
        </DoItems.DoItem>

        <DoItems.DoItem
          headline={
            <span>
              <Strong>Mobile</Strong> Development
            </span>
          }
          icon={mobileSvg}
        >
          <DoItems.Row>Responsive Webdesign</DoItems.Row>
          <DoItems.Row>Mobile- & Touchoptimierung</DoItems.Row>
          <DoItems.Row>Progressive Web-Apps (PWAs)</DoItems.Row>
          <DoItems.Row>Performance- & Ladezeitenoptimierung</DoItems.Row>
          <DoItems.Row>Cross-Plattform Native Apps mit Flutter</DoItems.Row>
        </DoItems.DoItem>
      </Col>

      <Col>
        <DoItems.DoItem
          headline={
            <span>
              Code<Strong>Qualität</Strong>
            </span>
          }
          icon={qualitySvg}
        >
          <DoItems.Row>Test Driven Development</DoItems.Row>
          <DoItems.Row>Support bei großen Refactorings</DoItems.Row>
          <DoItems.Row>Einhaltung von Design Patterns</DoItems.Row>
          <DoItems.Row>SOLID Principles</DoItems.Row>
          <DoItems.Row>Clean Architecture & Clean Architecture</DoItems.Row>
        </DoItems.DoItem>

        <DoItems.DoItem
          headline={<Strong>BERATUNG</Strong>}
          icon={consultingSvg}
        >
          <DoItems.Row>Ansprechpartner für Design und Konzept</DoItems.Row>
          <DoItems.Row>Architekturberatung</DoItems.Row>
        </DoItems.DoItem>
      </Col>
    </Row>
  </ContentSection>
);



// WEBPACK FOOTER //
// ./src/components/WhatIDo.js